module.exports = __webpack_public_path__ + "img/mood02.0a4425f0.jpg";